namespace ui
{
	export namespace Form
	{

		export interface ITextAreaDescriptor extends IBasicInputDescriptor
		{
			text?: string;
			rows?: number;
			cols?: number;
		}

		export class TextArea
			extends BasicInputField<HTMLTextAreaElement, ITextAreaDescriptor>
		{

			public readonly	Default: string;

			public constructor( descriptor: ITextAreaDescriptor )
			{
				super( 'textarea', descriptor, InputValueTypes.STRING );

				this.Default	= descriptor.text || '';
			}

			public reset(): void
			{
				this.m_Root.text( this.Default );
			}

			public value( val: string|null ): TextArea
			{
				this.m_Root.text( val || '' );

				return this;
			}

			public val(): string|null
			{
				const text = this.m_Root.val();

				return typeof text === 'string' && text.length > 0 ? text : null;
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.text )
				{
					this.m_Root.text( this.Descriptor.text );
				}
				if ( this.Descriptor.rows )
				{
					this.m_Root.attr( 'rows', this.Descriptor.rows );
				}
				if ( this.Descriptor.cols )
				{
					this.m_Root.attr( 'cols', this.Descriptor.cols );
				}
			}

		}

	}
}
